export const Card = ({item}) => {
  return (
    <div className='py-8 px-12 bg-[#17243f] rounded-[46px] flex items-center flex-col text-white border-r border-b border-[#00AA6C]'>
        <div className='h-[172px] w-[172px]'>
            <img src={item.icon} alt="" className='h-full w-full'/>
        </div>
        <p className='font-oxanium font-medium font-[20px] text-center mt-4 mb-2'>{item.title}</p>
        <p className='font-lato font-light font-[18px] text-center '>{item.desc}</p>
    </div>
  )
}
